import { render, staticRenderFns } from "./billtar.vue?vue&type=template&id=63fc4739&scoped=true"
import script from "./billtar.vue?vue&type=script&lang=js"
export * from "./billtar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc4739",
  null
  
)

export default component.exports